module["exports"] = [
  "SARL",
  "SA",
  "EURL",
  "SAS",
  "SEM",
  "SCOP",
  "GIE",
  "EI"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/fr/company/suffix.js
// module id = 1334
// module chunks = 1